import { state, style, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Holiday } from '@classes/holiday/holiday';
import { HolidayGroup } from '@classes/holiday/holiday-group';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { HolidaysService } from '@services/holidays.service';
import { UiService } from '@services/ui.service';

@Component({
  selector: 'app-holidays',
  templateUrl: './holidays.component.html',
  styleUrls: ['./holidays.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' }))
    ])
  ]
})
export class HolidaysComponent extends DatatableBaseComponent implements OnInit {
  holidayGroups: HolidayGroup[];
  holidays: Holiday[];
  groupForm = new UntypedFormGroup({
    group: new UntypedFormControl('', Validators.required)
  })

  isLoading = false;

  dataSource: MatTableDataSource<Holiday>;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns = ['date', 'description', 'actions'];

  constructor(
    protected uiSrv: UiService,
    private route: ActivatedRoute,
    private holidaysSrv: HolidaysService
  ) {
    super(uiSrv);
  }

  ngOnInit(): void {
    this.getRouteData();
    this.initSub();
  }

  private getRouteData(): void {
    this.route.data
      .subscribe((data: { holidayGroups: any[] }) => {
        this.holidayGroups = data.holidayGroups;
      });
  }

  initSub() {
    this.addSubscription(
      this.holidaysSrv.holidaysListChanged
        .subscribe(holidays => {
          if (this.dataSource) {
            this.dataSource.data = holidays || [];
            this.dataSource.sort = this.sort;
          }

          this.onEditFinished();
        })
    );
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.holidays);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

    this.initSub();
  }

  getGroupControl(control: string): UntypedFormControl {
    return this.groupForm.get(control) as UntypedFormControl;
  }

  chooseHolidayGroup() {
    this.isLoading = true;
    let id = this.groupForm.value.group.id;

    const holidayGroupPromise = new Promise((resolve, reject) => {
      this.holidaysSrv.get(id)
        .subscribe(holidaysSrv => {
          this.holidays = holidaysSrv;
          resolve(true);
        });
    });

    Promise.all([holidayGroupPromise])
      .then(() => {
        this.isLoading = false;
        this.initTable();
      });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  delete(idHoliday: string) {
    const confirmation = confirm('Êtes-vous certain de vouloir supprimer ce jour férié ?');

    if (confirmation) {
      this.holidaysSrv.delete(idHoliday).subscribe(() => {
        this.uiSrv.showSnackbar('billing.holidays.list.deleted', true);
      });
    }
  }
}
